<template>
  <div>
    <BlocoFiltroPesquisa
      v-if="!gerado"
      nome-do-form="MediaEvaEspecialidade"
      :botao-download="true"
      :botao-adicionar="false"
      @pesquisar="pesquisar"
      @download="download"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div class="form-group">
              <SelecionarEspecialidade
                id="especialidade"
                :mostrar-todos="false"
                :mostrar-selecione="true"
                :usar-id-como-value="true"
                :valor="filtro.especialidade"
                :validacao="v$.filtro.especialidde"
                @atualizar="filtro.especialidade = $event"
              />
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div
              :class="{ 'has-error': v$.filtro.dataInicio.$error }"
              class="form-group"
            >
              <label for="dataInicio">Data Início</label>
              <div class="input-group">
                <input
                  id="dataInicio"
                  v-model="filtro.dataInicio"
                  v-mask="'99/99/9999'"
                  data-test-id="input-datainicio"
                  name="dataInicio"
                  type="text"
                  class="form-control"
                  placeholder="DD/MM/AAAA"
                />
                <div class="input-group-addon">
                  <span
                    type="button"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="fa fa-calendar" />
                  </span>
                  <span class="dropdown-menu dropdown-menu-right">
                    <li>
                      <DatePicker
                        v-model="filtro.dataInicio"
                        :today-btn="false"
                        :clear-btn="false"
                        :format="'dd/MM/yyyy'"
                        :close-on-selected="true"
                        :date-parser="dataParser"
                        class="date-picker"
                      />
                    </li>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
            <div
              :class="{ 'has-error': v$.filtro.dataInicio.$error }"
              class="form-group"
            >
              <label for="dataFim">Data Fim</label>
              <div class="input-group">
                <input
                  id="dataFim"
                  v-model="filtro.dataFim"
                  v-mask="'99/99/9999'"
                  data-test-id="input-datafim"
                  name="dataFim"
                  type="text"
                  class="form-control"
                  placeholder="DD/MM/AAAA"
                />
                <div class="input-group-addon">
                  <span
                    type="button"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="fa fa-calendar" />
                  </span>
                  <span class="dropdown-menu dropdown-menu-right">
                    <li>
                      <DatePicker
                        v-model="filtro.dataFim"
                        :today-btn="false"
                        :clear-btn="false"
                        :format="'dd/MM/yyyy'"
                        :close-on-selected="true"
                        :date-parser="dataParser"
                        class="date-picker"
                      />
                    </li>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>

    <div v-if="!gerado">
      <div
        v-if="mediasEvaPorEspecialidade.length > 0"
        class="row"
        style="margin-top: 2rem"
      >
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="pull-right">
            <button type="button" class="btn btn-info" @click="gerado = true"
              >Gerar relatório</button
            >
            <button type="button" class="btn btn-success" @click="marcarTodos()"
              >Marcar todos</button
            >
            <button
              type="button"
              class="btn btn-danger"
              @click="desmarcarTodos()"
              >Desmarcar todos</button
            >
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div
            v-for="(mediasEva, index) in mediasEvaPorEspecialidade"
            id="panels"
            :key="mediasEva.cid"
            class="panel-group"
            role="tablist"
            aria-multiselectable="true"
          >
            <div class="panel panel-primary">
              <div
                :id="'mediaEvaItemTitulo' + index"
                class="panel-heading"
                role="tab"
              >
                <input :value="mediasEva" type="checkbox" />
                <a
                  :data-target="'#mediaEvaItemCorpo' + index"
                  :aria-controls="'mediaEvaItemCorpo' + index"
                  role="button"
                  data-toggle="collapse"
                  data-parent="#panels"
                  aria-expanded="false"
                >
                  <span class="cid">{{ mediasEva.cid }}</span>
                  <span class="resumo pull-right">
                    <strong>Total de sessões:</strong>
                    {{ mediasEva.totalSessoes }}
                  </span>
                </a>
              </div>
              <div
                :id="'mediaEvaItemCorpo' + index"
                :aria-labelledby="'mediaEvaItemTitulo' + index"
                class="panel-collapse collapse"
                role="tabpanel"
              >
                <table class="table table-striped table-hover table-bordered">
                  <thead>
                    <tr style="background-color: #008080">
                      <td class="text-center tabela-head"> Medição </td>
                      <td class="text-center tabela-head"> Inicial </td>
                      <td class="text-center tabela-head"> Final </td>
                      <td class="text-center tabela-head"> Melhora </td>
                      <td class="text-center tabela-head"> Piora </td>
                      <td class="text-center tabela-head"> Inalterado </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left cell">EVA</td>
                      <td class="text-right cell">{{
                        mediasEva.medias['EVA'].primeiraSessao
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.medias['EVA'].ultimaSessao
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.eva.melhora
                      }}</td>
                      <td class="text-right cell">{{ mediasEva.eva.piora }}</td>
                      <td class="text-right cell">{{
                        mediasEva.eva.inalterado
                      }}</td>
                    </tr>
                    <tr>
                      <td class="text-left cell">Intensidade da Queixa</td>
                      <td class="text-right cell">{{
                        mediasEva.medias['Intensidade Queixa'].primeiraSessao
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.medias['Intensidade Queixa'].ultimaSessao
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.intensidadeQueixa.melhora
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.intensidadeQueixa.piora
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.intensidadeQueixa.inalterado
                      }}</td>
                    </tr>
                    <tr>
                      <td class="text-left cell">Dificuldade da Queixa</td>
                      <td class="text-right cell">{{
                        mediasEva.medias['Dificuldade Queixa'].primeiraSessao
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.medias['Dificuldade Queixa'].ultimaSessao
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.dificuldadeQueixa.melhora
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.dificuldadeQueixa.piora
                      }}</td>
                      <td class="text-right cell">{{
                        mediasEva.dificuldadeQueixa.inalterado
                      }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="gerado">
      <div>
        <div class="row pull-right">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <button type="button" class="btn btn-danger" @click="gerado = false"
              >Voltar</button
            >
          </div>
        </div>
        <div v-if="filtro && mediasEvaPorEspecialidade">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h1>Relatório de Média EVA</h1>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <td>Especialidade</td>
                    <td>Data Início</td>
                    <td>Data Fim</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{
                      especialidades.find((e) => e._id == filtro.especialidade)
                        .nome
                    }}</td>
                    <td>{{ filtro.dataInicio }}</td>
                    <td>{{ filtro.dataFim }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            v-for="mediasEva in mediasEvaPorEspecialidade"
            :key="mediasEva.cid"
          >
            <br />
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <h3>{{ mediasEva.cid }}</h3>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Medição</th>
                      <th>Inicial</th>
                      <th>Final</th>
                      <th>Melhora</th>
                      <th>Piora</th>
                      <td>Inalterado</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>EVA</td>
                      <td class="text-right">{{
                        mediasEva.medias['EVA'].primeiraSessao
                      }}</td>
                      <td class="text-right">{{
                        mediasEva.medias['EVA'].ultimaSessao
                      }}</td>
                      <td class="text-right">{{ mediasEva.eva.melhora }}</td>
                      <td class="text-right">{{ mediasEva.eva.piora }}</td>
                      <td class="text-right">{{ mediasEva.eva.inalterado }}</td>
                    </tr>
                    <tr>
                      <td>Intensidade da Queixa</td>
                      <td class="text-right">{{
                        mediasEva.medias['Intensidade Queixa'].primeiraSessao
                      }}</td>
                      <td class="text-right">{{
                        mediasEva.medias['Intensidade Queixa'].ultimaSessao
                      }}</td>
                      <td class="text-right">{{
                        mediasEva.intensidadeQueixa.melhora
                      }}</td>
                      <td class="text-right">{{
                        mediasEva.intensidadeQueixa.piora
                      }}</td>
                      <td class="text-right">{{
                        mediasEva.intensidadeQueixa.inalterado
                      }}</td>
                    </tr>
                    <tr>
                      <td>Dificuldade da Queixa</td>
                      <td class="text-right">{{
                        mediasEva.medias['Dificuldade Queixa'].primeiraSessao
                      }}</td>
                      <td class="text-right">{{
                        mediasEva.medias['Dificuldade Queixa'].ultimaSessao
                      }}</td>
                      <td class="text-right">{{
                        mediasEva.dificuldadeQueixa.melhora
                      }}</td>
                      <td class="text-right">{{
                        mediasEva.dificuldadeQueixa.piora
                      }}</td>
                      <td class="text-right">{{
                        mediasEva.dificuldadeQueixa.inalterado
                      }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import { DatePicker } from 'uiv'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import SelecionarEspecialidade from '@/componentes/formulario/SelecionarEspecialidade'
import { useMenu } from '@/composables/useMenu'
import EspecialidadeServico from '@/servicos/EspecialidadeServico'
import MensagemServico from '@/servicos/MensagemServico'
import RelatorioServico from '@/servicos/RelatorioServico'

const mensagemServico = new MensagemServico()
const relatorioServico = new RelatorioServico()
const especialidadeServico = new EspecialidadeServico()

export default {
  components: { DatePicker, BlocoFiltroPesquisa, SelecionarEspecialidade },
  directives: { mask: AwesomeMask },
  setup() {
    useMenu(71)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      mediasEvaPorEspecialidade: [],
      especialidades: [],
      gerado: false,
      filtro: {
        especialidade: '',
        dataInicio: moment().startOf('month').format('DD/MM/YYYY'),
        dataFim: moment().endOf('month').format('DD/MM/YYYY'),
      },
    }
  },
  created() {
    this.recuperarEspecialidades()
  },
  validations: {
    filtro: {
      especialidade: { required },
      dataInicio: { required },
      dataFim: { required },
    },
  },
  methods: {
    pesquisar() {
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Preencha os campos corretamente.')
      } else {
        relatorioServico
          .relatorioMediaEvaPorEspecialidade({
            especialidade: this.filtro.especialidade,
            dataInicio: moment(this.filtro.dataInicio, 'DD/MM/YYYY').format(
              'YYYY-MM-DDTHH:mm:ss[Z]'
            ),
            dataFim: moment(this.filtro.dataFim, 'DD/MM/YYYY').format(
              'YYYY-MM-DDTHH:mm:ss[Z]'
            ),
          })
          .then((result) => {
            console.log(result.relatorio)
            this.mediasEvaPorEspecialidade = result.relatorio
          })
      }
    },
    download() {
      this.v$.$touch()

      if (this.v$.filtro.$invalid) {
        mensagemServico.alerta('Preencha os campos corretamente.')
      } else {
        relatorioServico
          .relatorioMediaEvaPorEspecialidadeDownload({
            especialidade: this.filtro.especialidade,
            dataInicio: moment(this.filtro.dataInicio, 'DD/MM/YYYY').format(
              'YYYY-MM-DDTHH:mm:ss[Z]'
            ),
            dataFim: moment(this.filtro.dataFim, 'DD/MM/YYYY').format(
              'YYYY-MM-DDTHH:mm:ss[Z]'
            ),
          })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'report.xlsx')
            document.body.appendChild(link)
            link.click()
          })
      }
    },
    limparFiltro() {
      this.filtro.especialidade = ''
      this.filtro.dataInicio = moment().startOf('month').format('DD/MM/YYYY')
      this.filtro.dataFim = moment().endOf('month').format('DD/MM/YYYY')
    },
    recuperarEspecialidades() {
      especialidadeServico.recuperarTodos().then((result) => {
        this.especialidades = result.especialidades
      })
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
  },
}
</script>

<style scoped>
.cid {
  margin: 0 15px;
  font-size: 16px;
  color: #ecf0f1;
}

.resumo {
  margin: 0 5px;
  font-size: 14px;
  color: #ecf0f1;
}

.cell {
  vertical-align: middle;
}

.tabela-head {
  font-weight: 600;
  color: #ecf0f1;
}
</style>
